import { render, staticRenderFns } from "./PermittedFunctionSwitch.vue?vue&type=template&id=c753e2e2&scoped=true&lang=pug"
import script from "./PermittedFunctionSwitch.vue?vue&type=script&lang=ts"
export * from "./PermittedFunctionSwitch.vue?vue&type=script&lang=ts"
import style0 from "./PermittedFunctionSwitch.vue?vue&type=style&index=0&id=c753e2e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c753e2e2",
  null
  
)

export default component.exports